var render = function render(){var _vm=this,_c=_vm._self._c;return _c('auto-line-chart',_vm._b({ref:"lineChart",attrs:{"query-api":_vm.queryApi,"query-body":_vm.queryBody,"data-formatter":_vm.dataFormatter}},'auto-line-chart',_vm.$attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }